import { defineComponent as w, computed as l, createBlock as v, createElementBlock as b, openBlock as t, mergeProps as s, unref as e, renderSlot as c } from "vue";
import S from "../Divider.vue2.js";
import { classesFromBreakpointProps as p, breakpoints as h } from "../../breakpoints.js";
import { toCamelCase as G } from "../../util.js";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import { c_toolbar__item_Width as y } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_toolbar__item_Width.js";
import { useOUIAProps as I } from "../../helpers/ouia.js";
const C = ["aria-hidden"], P = /* @__PURE__ */ w({
  name: "PfToolbarItem",
  __name: "ToolbarItem",
  props: {
    variant: {},
    alignItems: {},
    alignSelf: {},
    allExpanded: { type: Boolean },
    overflowContainer: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    visibility: {},
    visibilitySm: {},
    visibilityMd: {},
    visibilityLg: {},
    visibilityXl: {},
    visibility2xl: {},
    align: {},
    alignSm: {},
    alignMd: {},
    alignLg: {},
    alignXl: {},
    align2xl: {},
    width: {},
    widthSm: {},
    widthMd: {},
    widthLg: {},
    widthXl: {},
    width2xl: {},
    gap: {},
    gapSm: {},
    gapMd: {},
    gapLg: {},
    gapXl: {},
    gap2xl: {},
    columnGap: {},
    columnGapSm: {},
    columnGapMd: {},
    columnGapLg: {},
    columnGapXl: {},
    columnGap2xl: {},
    rowGap: {},
    rowGapSm: {},
    rowGapMd: {},
    rowGapLg: {},
    rowGapXl: {},
    rowGap2xl: {},
    rowWrap: {},
    rowWrapSm: {},
    rowWrapMd: {},
    rowWrapLg: {},
    rowWrapXl: {},
    rowWrapXl2: {}
  },
  emits: ["clear-all-filters"],
  setup(m) {
    const o = m, d = I({ id: o.ouiaId, safe: o.ouiaSafe }), f = l(() => [
      ...p(o, ["visibility", "rowWrap"], i, { short: !0 }),
      ...p(o, ["align", "gap", "columnGap", "rowGap"], i)
    ]), g = l(() => {
      const a = {};
      for (const r of h) {
        const n = `width${r}`;
        o[n] && (a[`${y.name}${r ? `-on-${r.toLowerCase()}` : ""}`] = o[n]);
      }
      return a;
    }), u = l(() => o.variant && o.variant !== "separator" ? i.modifiers[G(o.variant)] : null);
    return (a, r) => a.variant == "separator" ? (t(), v(S, s({ key: 0 }, a.$attrs, { orientation: "vertical" }), null, 16)) : (t(), b("div", s({
      key: 1,
      class: [e(i).toolbarItem, f.value, u.value, {
        [e(i).modifiers.pagination]: a.variant == "pagination",
        [e(i).modifiers.label]: a.variant == "label",
        [e(i).modifiers.labelGroup]: a.variant == "label-group",
        [e(i).modifiers.expanded]: a.allExpanded,
        [e(i).modifiers.overflowContainer]: a.overflowContainer,
        [e(i).modifiers.alignItemsStart]: a.alignItems === "start",
        [e(i).modifiers.alignItemsCenter]: a.alignItems === "center",
        [e(i).modifiers.alignItemsBaseline]: a.alignItems === "baseline",
        [e(i).modifiers.alignSelfStart]: a.alignSelf === "start",
        [e(i).modifiers.alignSelfCenter]: a.alignSelf === "center",
        [e(i).modifiers.alignSelfBaseline]: a.alignSelf === "baseline"
      }],
      style: g.value,
      "aria-hidden": a.variant == "label"
    }, { ...e(d), ...a.$attrs }), [
      c(a.$slots, "default")
    ], 16, C));
  }
});
export {
  P as default
};
